/* ============================================
   DRINK NIU — THEME JS
   Form tag enrichment + Scroll reveals + Tea selector
   ============================================ */

// Fold optional first/last name (and tea preference on the waitlist form)
// into the hidden contact[tags] field just before the browser submits the
// real Shopify customer form. This runs synchronously and does NOT
// intercept or preventDefault the submission, so Shopify's invisible
// CAPTCHA can still attach its token to the real <form> the normal way.
function foldNameIntoTags(formId, fnameId, lnameId, tagsId) {
  const fnameEl = document.getElementById(fnameId);
  const lnameEl = document.getElementById(lnameId);
  const tagsEl = document.getElementById(tagsId);
  if (!tagsEl) return;
  const fullName = [fnameEl && fnameEl.value.trim(), lnameEl && lnameEl.value.trim()]
    .filter(Boolean)
    .join(' ');
  if (fullName) {
    tagsEl.value += ', name:' + fullName.replace(/,/g, ' ');
  }
}

document.addEventListener('submit', function (e) {
  const form = e.target;

  if (form.id === 'hero-customer-form') {
    foldNameIntoTags(form.id, 'hero-fname', 'hero-lname', 'hero-tags');
  }

  if (form.id === 'waitlist-customer-form') {
    foldNameIntoTags(form.id, 'wl-fname', 'wl-lname', 'wl-tags');

    const activeTea = document.querySelector('.tea-sel-btn.active');
    const tagsEl = document.getElementById('wl-tags');
    if (activeTea && tagsEl) {
      tagsEl.value += ', tea:' + activeTea.dataset.tea;
    }
  }

  if (form.id === 'brewer-customer-form') {
    foldNameIntoTags(form.id, 'brewer-fname', 'brewer-lname', 'brewer-tags');
  }
});

// ── Tea selector ──────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const btns = document.querySelectorAll('.tea-sel-btn');
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── Scroll reveal ──────────────────────────
  const targets = document.querySelectorAll(
    '.science-card, .disc, .sub-tier, .brewer-section, .founder-inner, ' +
    '.manifesto-section, .tea-high-bar, .sub-includes, .sourced-pillars'
  );

  targets.forEach(el => el.classList.add('reveal-on-scroll'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  targets.forEach(el => observer.observe(el));
});
